/* eslint-disable no-unused-vars */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from "react";

import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

import { Text } from "components";
import apiRequest from "helpers/apiRequest";
import ErrorAlert from "components/ErrorAlert";

const AddTypeModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [type, setType] = useState({
    value: "",
    invalidName: false,
    additionalInfo: "",
  });
  const [error, setError] = useState(null);

  const saveType = async () => {
    try {
      const response = await apiRequest({
        method: "post",
        url: "species",
        data: {
          name: type.value,
          additionalInfo: type.additionalInfo,
        },
      });
      if (response.status === 200) {
        setType({
          value: "",
          invalidName: false,
          additionalInfo: "",
        });
        onClose();
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        history.push("/auth/login");
      }
      createError(err?.response?.data?.error);
    }
  };

  const checkText = () => {
    const data = { ...type };
    if (data.value === "") {
      data.invalidName = true;
      setType({ ...data });
    } else {
      saveType();
    }
  };
  const createError = (msg = "fillAllFields") => {
    setError(<ErrorAlert errorText={msg} />);
    setTimeout(() => {
      setError(null);
    }, 3000);
  };
  const clear = () => {
    setType(null);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="w-full   p-5 relative mx-auto my-auto ">
        {error}
        <div className="w-full ">
          <div className="mb-1">
            <Text>{t("typesName")}</Text>
          </div>
          <div className="flex ">
            <div className="h-10 w-full">
              <input
                className={`h-full w-full px-5 rounded-lg border ${
                  type.invalidName && "border-2 border-red"
                }`}
                value={type.value.charAt(0).toUpperCase() + type.value.slice(1)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    checkText();
                  }
                }}
                onChange={(e) =>
                  setType({
                    ...type,
                    value: e.target.value,
                    invalidName: false,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="w-full mt-4 ">
          <div className="mb-1">
            <Text>{t("additionalInfo")}</Text>
          </div>
          <div className="flex ">
            <div className="h-10 w-full">
              <input
                className={`h-full w-full px-5 rounded-lg border`}
                value={
                  type.additionalInfo.charAt(0).toUpperCase() +
                  type.additionalInfo.slice(1)
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    checkText();
                  }
                }}
                onChange={(e) =>
                  setType({
                    ...type,
                    additionalInfo: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="">
          <div className="p-3  mt-2 text-center space-x-4 md:block">
            <button
              className="mb-2 md:mb-0 bg-white px-5 py-2 text-sm shadow-sm font-medium tracking-wider border text-gray-600 rounded-lg hover:shadow-lg hover:bg-gray-100"
              onClick={onClose}
            >
              {t("cancel")}
            </button>
            <button
              className="mb-2 md:mb-0 bg-white px-5 py-2 text-sm shadow-sm font-medium tracking-wider border border-blue-primary text-blue-primary rounded-lg hover:shadow-lg hover:bg-gray-100"
              onClick={checkText}
            >
              {t("addType")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddTypeModal;
